module.exports = __webpack_public_path__ + "e602cdd348f8e4cf4a270896d2fd754b.svg";